import { ReactNode, useEffect, useMemo } from "react";
// components
import Button from "../components/Button";
import JourneysList from "../components/JourneysList";
import PageHeading from "../components/PageHeading";
// @types
import { JourneyDataType } from "../@types/travel";
// styles
import sx from "../styles/pages/journeys/JourneysPage.module.css";

interface JourneysPageProps {
  primaryData: JourneyDataType[];
  setActiveStep: (step: number) => void;
  deleteQuote: (id: string) => void;
  createMultipleQuoteByEstimate: (e: React.MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => void;
  setEstimateIds: (ids: string[]) => void;
  isLoading: boolean;
  JourneysPageSubtitle: ReactNode;
  restoreDefaultState: () => void;
}

const JourneysPage: React.FC<JourneysPageProps> = ({
  primaryData,
  setActiveStep,
  deleteQuote,
  createMultipleQuoteByEstimate,
  setEstimateIds,
  isLoading,
  JourneysPageSubtitle,
  restoreDefaultState,
}) => {
  const ids = useMemo(() => primaryData?.map(el => el?.estimate?.estimateId || (el as any)?.estimate?.id), [primaryData]);

  useEffect(() => {
    if (ids) {
      setEstimateIds(ids);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ids]);

  return (
    <>
      <div className={`${sx.container} delayed-fadein`} style={{ justifyContent: "space-between" }}>
        <div>
          <PageHeading
            title={"Your journey itinerary"}
            text={"You can offset your journey and contribute to meaningful climate projects that reduce carbon emissions"}
            subtitle={JourneysPageSubtitle}
          />

          <div className={sx.controls}>
            <JourneysList
              list={primaryData}
              deleteQuote={deleteQuote}
              setActiveStep={setActiveStep}
            />
          </div>
        </div>
      </div>

      <div className={sx.container} style={{ gap: '0.5rem' }}>
        <Button
          text="Offset"
          variant="filled"
          onClick={createMultipleQuoteByEstimate}
          isLoading={isLoading}
          disabled={!ids?.length}
        />

      <Button
        text="Start again"
        variant="arrow"
        iconName="back"
        onClick={restoreDefaultState}
      />
      </div>
    </>
  );
};

export default JourneysPage;

